import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

const DEFAULT_PAGE = 'Main'

export const usePageStore = defineStore('app/page', () => {
  // State -----------------------------------------
  const page = ref(DEFAULT_PAGE)
  const refreshPageTrigger = ref(false)

  // Getters ---------------------------------------

  // Actions ---------------------------------------
  function $reset() {
    page.value = DEFAULT_PAGE
    refreshPageTrigger.value = false
  }

  function changePage(name) {
    page.value = name
  }

  function refreshPage() {
    refreshPageTrigger.value = !refreshPageTrigger.value
  }

  // Main Setup ------------------------------------  

  // -----------------------------------------------
  return { page, refreshPageTrigger, $reset, changePage, refreshPage }
})
